export enum InstallIntegrationSteps {
	HOST = 'HOST',
	AUTHORIZATION = 'AUTHORIZATION',
	MAPPING = 'MAPPING',
	SETTINGS = 'SETTINGS',
}
